import React, { useContext } from "react";
import { Link } from "react-router-dom";

import { Container } from "../styled.ts";
import { useMobile } from "../../hooks/isMobile.tsx";
import { LinksSection } from "./linkSection.tsx";
import { LogoIcon } from "../icons/logo.tsx";
import { subscriberContext } from "../../context/subscriberContext.tsx";

export const Header = ({ active = "home" }) => {
  const { isMobile } = useMobile();
  const { subscriberDetails } = useContext(subscriberContext);
  return (
    <Container
      padding={isMobile ? "5px 15px" : "15px 54px 15px 54px"}
      margin="0"
      justifyContent="space-between"
      background={"#fff"}
      style={{boxShadow: "0px 0.5px 0px 0px rgba(0, 0, 255, 0.1)", top:0, position: "sticky", zIndex: 1}}

    >
      <Link
        to={subscriberDetails?.phoneNumber ? "/watch-list" : "/"}
        style={{ display:"flex", flex:'0.4',alignItems: "center", cursor: "pointer" }}
      >
        { <LogoIcon  height={isMobile ?"35":"50"}/> }
      </Link>
      <LinksSection active={active} />
    </Container>
  );
};
